"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllianceOrderUpdateInput = exports.AllianceOrderCreateInput = exports.AllianceOrderCustomerTransport = exports.AllianceOrderTransport = exports.CheckoutType = exports.CheckoutTypes = exports.PartnerCheckout = exports.PartnerCheckouts = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const receivable_transport_1 = require("../invoice/receivable-transport");
const roll_off_pricing_snapshot_1 = require("../pricing/roll-off-pricing-snapshot");
const alliance_order_switch_transport_1 = require("./alliance-order-switch-transport");
const order_status_1 = require("./order-status");
const vendor_pricing_snapshot_transport_1 = require("./vendor-pricing-snapshot-transport");
exports.PartnerCheckouts = ['PITCH_GAUGE_ONLINE'];
exports.PartnerCheckout = typebox_1.Type.Union(exports.PartnerCheckouts.map((t) => typebox_1.Type.Literal(t)));
// To see descriptions of when to use each checkout type, see the following Notion page:
// https://www.notion.so/sourgum/Sourgum-Roll-off-Orders-ee7ad80e415b43c688a279dd4d34c24e (if you can't find the page search for "Checkout Types")
// If you add a new enum value, add a description to the Notion page
exports.CheckoutTypes = [
    'SELF_CHECKOUT',
    'GUIDED_CHECKOUT',
    'AGENT',
    'CUSTOMER_PORTAL',
    /**@deprecated */
    'MAIN_SITE',
    /**@deprecated */
    'OTHER',
    ...exports.PartnerCheckouts,
];
exports.CheckoutType = typebox_1.Type.Union(exports.CheckoutTypes.map((t) => typebox_1.Type.Literal(t)));
exports.AllianceOrderTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' }))),
    poNumber: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    orderNumber: typebox_1.Type.Optional(typebox_1.Type.Number()),
    status: order_status_1.OrderStatus,
    allowedNextStatuses: typebox_1.Type.Array(typebox_1.Type.String()),
    serviceLocationID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    serviceLocation: common_1.ServiceLocationTransport,
    allianceCustomerID: typebox_1.Type.String({ format: 'uuid' }),
    requestedDeliveryDate: typebox_1.Type.String(),
    expectedDeliveryDate: typebox_1.Type.String(),
    requestedPickupDate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    expectedPickupDate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    rentalEndDate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    expirationDate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    requestedSize: typebox_1.Type.Object({ size: typebox_1.Type.Number(), type: typebox_1.Type.String() }),
    expectedSize: typebox_1.Type.Object({ size: typebox_1.Type.Number(), type: typebox_1.Type.String() }),
    sharedPickupNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    sharedDeliveryNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    sharedPickupNotesPrivate: typebox_1.Type.Optional(typebox_1.Type.String()),
    sharedDeliveryNotesPrivate: typebox_1.Type.Optional(typebox_1.Type.String()),
    dumpTicketNumber: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    images: typebox_1.Type.Array(common_1.S3ItemReference),
    switches: typebox_1.Type.Array(alliance_order_switch_transport_1.AllianceOrderSwitchTransport),
    material: common_1.Material,
    weightLimit: typebox_1.Type.Optional((0, common_1.Nullable)(common_1.Weight)),
    actualWeightDumped: typebox_1.Type.Optional((0, common_1.Nullable)(common_1.Weight)),
    originalRentalPeriod: common_1.Duration,
    adjustedRentalPeriod: common_1.Duration,
    extendingRental: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Boolean())),
    needsAttention: typebox_1.Type.Boolean(),
    needsAttentionBilling: typebox_1.Type.Boolean(),
    recurringOnCall: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Boolean())),
    haulerConfirmedDelivery: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Boolean())),
    haulerConfirmedPickup: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Boolean())),
    ccRate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    haulerDumpRate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    haulerDumpRateDollars: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    haulerHaulRate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    haulerHaulRateDollars: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    haulerPricingSnapshot: typebox_1.Type.Optional((0, common_1.Nullable)(roll_off_pricing_snapshot_1.RollOffPricingSnapshot)),
    dumpRate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    dumpRateDollars: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    rentExtensionFee: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    rentExtensionFeeDollars: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    overage: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    overageDollars: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    taxRate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    priceType: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    paymentMethod: typebox_1.Type.Optional((0, common_1.Nullable)(common_1.PaymentMethod)),
    paymentTerm: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Integer({ minimum: 0 }))),
    checkoutType: typebox_1.Type.Optional((0, common_1.Nullable)(exports.CheckoutType)),
    affiliateTrackingID: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    closed: typebox_1.Type.Boolean(),
    accountManagerID: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' }))),
    accountRepID: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' }))),
    customerName: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerCompanyName: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerAccountNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
    accountManagerName: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    accountRepName: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    sourgumPricingSnapshot: typebox_1.Type.Optional((0, common_1.Nullable)(roll_off_pricing_snapshot_1.RollOffPricingSnapshot)),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
    changes: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Object({
        id: typebox_1.Type.String({ format: 'uuid' }),
        orderID: typebox_1.Type.String(),
        changes: typebox_1.Type.Array(typebox_1.Type.Object({
            id: typebox_1.Type.String(),
            status: typebox_1.Type.String(),
            field: typebox_1.Type.Union([
                typebox_1.Type.Literal('expectedDeliveryDate'),
                typebox_1.Type.Literal('expectedPickupDate'),
                typebox_1.Type.Literal('sharedDeliveryNotes'),
                typebox_1.Type.Literal('sharedPickupNotes'),
                typebox_1.Type.Literal('material'),
                typebox_1.Type.Literal('expectedSize'),
                typebox_1.Type.Literal('status'),
            ]),
            oldValue: typebox_1.Type.Optional(typebox_1.Type.String()),
            newValue: typebox_1.Type.String(),
            notes: typebox_1.Type.Optional(typebox_1.Type.String()),
            metadata: typebox_1.Type.Object({
                createdAt: typebox_1.Type.String(),
                createdByUserID: typebox_1.Type.String(),
                lastUpdatedAt: typebox_1.Type.String(),
                lastUpdatedByUserID: typebox_1.Type.String(),
            }),
        })),
        metadata: typebox_1.Type.Object({
            createdAt: typebox_1.Type.String(),
            createdByUserID: typebox_1.Type.String(),
            lastUpdatedAt: typebox_1.Type.String(),
            lastUpdatedByUserID: typebox_1.Type.String(),
        }),
    }))),
});
exports.AllianceOrderCustomerTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.AllianceOrderTransport, [
        'id',
        'serviceLocation',
        'orderNumber',
        'status',
        'poNumber',
        'material',
        'expectedSize',
        'expectedDeliveryDate',
        'expectedPickupDate',
        'expirationDate',
        'adjustedRentalPeriod',
        'rentExtensionFee',
        'sharedDeliveryNotes',
        'sharedPickupNotes',
        // Price? -- comes from invoice service
        'priceType',
        'weightLimit',
        'actualWeightDumped',
        'overage',
        'paymentTerm',
        'changes',
        'metadata',
        'switches',
    ]),
    typebox_1.Type.Object({
        receivables: typebox_1.Type.Optional(typebox_1.Type.Array(receivable_transport_1.CustomerReceivableTransport)),
        images: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.PreSignedS3Object)),
    }),
]);
exports.AllianceOrderCreateInput = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.AllianceOrderTransport, [
        'haulerID',
        'poNumber',
        'status',
        'serviceLocationID',
        'serviceLocation',
        'allianceCustomerID',
        'requestedDeliveryDate',
        'requestedPickupDate',
        'rentalEndDate',
        'expirationDate',
        'requestedSize',
        'sharedPickupNotes',
        'sharedDeliveryNotes',
        'sharedPickupNotesPrivate',
        'sharedDeliveryNotesPrivate',
        'material',
        'weightLimit',
        'originalRentalPeriod',
        'recurringOnCall',
        'ccRate',
        'haulerDumpRate',
        'haulerDumpRateDollars',
        'haulerHaulRate',
        'haulerHaulRateDollars',
        'dumpRate',
        'dumpRateDollars',
        'overage',
        'overageDollars',
        'rentExtensionFee',
        'rentExtensionFeeDollars',
        'taxRate',
        'priceType',
        'paymentMethod',
        'paymentTerm',
        'affiliateTrackingID',
        'haulerPricingSnapshot',
        'accountManagerID',
        'accountRepID',
        'customerName',
        'customerCompanyName',
        'customerAccountNumber',
        'vendorName',
        'accountManagerName',
        'accountRepName',
        'sourgumPricingSnapshot',
    ]),
    typebox_1.Type.Object({
        checkoutAttemptItemKey: typebox_1.Type.Optional(typebox_1.Type.String()),
        receivable: typebox_1.Type.Optional(receivable_transport_1.CreateAndChargeReceivableTransport),
        switchFromOrderID: typebox_1.Type.Optional(typebox_1.Type.String()),
        switchType: typebox_1.Type.Optional(typebox_1.Type.String()),
        checkoutType: exports.CheckoutType,
        orderAssignmentTableSnapshot: typebox_1.Type.Optional(vendor_pricing_snapshot_transport_1.VendorPricingSnapshotTransportCreate),
    }),
]);
exports.AllianceOrderUpdateInput = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.AllianceOrderTransport, [
        'id',
        'allowedNextStatuses',
        'images',
        'switches',
        'customerName',
        'customerCompanyName',
        'customerAccountNumber',
        'metadata',
        'changes',
    ]),
    typebox_1.Type.Object({ orderAssignmentTableSnapshot: vendor_pricing_snapshot_transport_1.VendorPricingSnapshotTransportCreate }),
]));
//# sourceMappingURL=alliance-order-transport.js.map